import React, { Component } from 'react'
import { Container, Row } from 'components/Layout'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import sMarg from 'styles/modules/margins.scss'
import { TemplateCard } from 'features/Flows/FlowCreateModal/FlowCreateModal'

const options = [
  {
    name: '1300 Number',
    description: 'Fixed pricing nation-wide',
    numberType: '1300',
  },
  {
    name: '1800 Number',
    description: 'Toll free to incentivise calls',
    numberType: '1800',
  },
  {
    name: 'Local Number',
    description: 'Select any locality',
    numberType: 'local',
  },
  {
    name: 'Mobile Number',
    description: 'Australian mobile number',
    numberType: 'mobile',
  },
  // {
  //   name: 'Virtual Mobile Service',
  //   description: 'Virtual Australian mobile number',
  //   numberType: 'virtual-mobile-service',
  // },
  // {
  //   name: 'International Number',
  //   description: 'For international customers',
  //   numberType: 'intl',
  // }
]

export default class NumbersNewServiceModal extends Component {
  render() {
    const { showNumbersFormModal, showMobileServiceFormModal, modalConfirm } = this.props

    return (
      <Container
        style={{ background: 'rgba(0, 0, 0, 0.03)', padding: '30px 30px 20px' }}
        className="sm"
      >
        <div className={cn(sText.descrip1, sMarg.mb30, sText.center)}>
          What type of service are you after?
        </div>
        <Row
          className={cn(
            sLay['layout-gt-xs-row'],
            sLay['layout-xs-column'],
            sLay['layout-wrap'],
            'sm'
          )}
        >
          {options.map(option => (
            <TemplateCard
              key={option.name}
              name={option.name}
              description={option.description}
              onClick={() =>
                option.numberType === 'virtual-mobile-service'
                  ? showMobileServiceFormModal().then(modalConfirm)
                  : showNumbersFormModal({ numberType: option.numberType }).then(modalConfirm)
              }
            />
          ))}
        </Row>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersNewServiceModal/NumbersNewServiceModal.jsx